import { SHADOW_DOM_STYLE_LOAD_EVENT } from '@backstage/plugin-techdocs-react';

const onCssReady = ({
  onLoading,
  onLoaded
}) => {
  return (dom) => {
    onLoading();
    dom.addEventListener(
      SHADOW_DOM_STYLE_LOAD_EVENT,
      function handleShadowDomStyleLoad() {
        onLoaded();
        dom.removeEventListener(
          SHADOW_DOM_STYLE_LOAD_EVENT,
          handleShadowDomStyleLoad
        );
      }
    );
    return dom;
  };
};

export { onCssReady };
//# sourceMappingURL=onCssReady.esm.js.map
